import { classnames } from '@aibees/shared/utils';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab, TabsProps } from '@mui/material';
import { memo, SyntheticEvent, useState } from 'react';

import { PresetVisibility } from '@aibees/shared/definition';
import { useMount } from '@aibees/shared/hooks';
import { useSearchListCardStore } from '../../store';
import { SearchListCardVisibility } from '../../types';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchCardTabsProps as Props } from './types';

export const SearchCardTabs = memo(
  ({ className, tabs, tabPanels, searchTable }: Props) => {
    const { setVisibility, title } = useSearchListCardStore();
    const [tab, setTab] = useState<PresetVisibility>(PresetVisibility.ALL);
    const handleTabChange: TabsProps['onChange'] = (
      event: SyntheticEvent,
      value: string
    ) => {
      setTab(value as PresetVisibility);
      setVisibility(value as SearchListCardVisibility);
    };

    useMount(() => {
      if (title) setVisibility(SearchListCardVisibility.ALL);
    });

    return (
      <Styled.Wrapper
        className={classnames('SearchCardTabs', className)}
        sx={SX.root}
        variant="outlined"
      >
        <TabContext value={tab}>
          <Box>
            <TabList
              onChange={handleTabChange}
              size="medium"
              variant="fullWidth"
            >
              {tabs.map((t) => (
                <Tab key={t.value} label={t.label} value={t.value} />
              ))}
            </TabList>
          </Box>

          {tabPanels.map((t) => (
            <TabPanel key={t.value} value={t.value} sx={SX.panel}>
              {searchTable}
            </TabPanel>
          ))}
        </TabContext>
      </Styled.Wrapper>
    );
  }
);

SearchCardTabs.displayName = 'SearchCardTabs';
